import type { TypeFullAPI } from '@openx/types/inventoryList.ts';
import type { UseInventoryListsOptionsFetch } from '@openx/types/targeting/targetingHookTypes.ts';
import { reduceOptionsByPath } from '@openx/utils/lib/reduceOptionsByPath.ts';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../hooks/useOptionsByPathQuery.ts';

export const useInventoryListsOptionsFetch: UseInventoryListsOptionsFetch = (
  type: TypeFullAPI,
  account_uid: string
) => {
  const { data, loading } = useOptionsByPathQuery({
    variables: {
      path: 'deal.package.targeting.inventorylist',
      filter: {
        type_full: type,
        account_uid,
      },
    },
    skip: !account_uid,
    fetchPolicy: 'network-only',
  });

  const mappedData = useMemo(() => reduceOptionsByPath(data?.optionsByPath), [data]);

  return { inventoryListsOptions: mappedData.options, mapById: mappedData.mapById, loading };
};
